module.exports = __webpack_public_path__ + "img/news.98292285.png";